import VoicePage from '@/components/Pages/VoicePage';

export default VoicePage;
